export default "__VITE_ASSET__D8oWika9__"